export class Dragable {
    constructor(element, targetElement, resizable = false, edges = null) {
        this.state = {
            initialPosition: [0, 0]
        }
        this.resizable = resizable
        this.edges = edges
        this.element = element
        this.targetElement = targetElement
        this.init()
    }

    init() {
        const [x, y] = this.initialPosition
        this.element.setAttribute('data-x', x)
        this.element.setAttribute('data-y', y)
        this.element.style.transform = `translate(${x}px, ${y}px)`
        this.element.style.position = 'absolute';
        this.element.style.zIndex = 10002000;
        if (this.element.nodeType) document.body.appendChild(this.element)
        else document.body.innerHTML = this.element
        this.setDragable()
    }

    setDragable() {
        try {
            this.interactable = interact(this.element)
                .draggable({
                    modifiers: [
                        interact.modifiers.restrict({
                            restriction: 'parent', // Ограничение перемещения внутри родительского элемента
                            endOnly: true
                        })
                    ],
                    allowFrom: this.targetElement || null,
                    // enable inertial throwing
                    inertia: true,
                    // keep the element within the area of it's parent
                    // enable autoScroll
                    autoScroll: true,
                    // call this function on every dragmove event
                    modifiers: [
                        interact.modifiers.restrictRect({
                            restriction: 'parent',
                            endOnly: true
                        })
                    ],
                    onmove: this.dragMoveListener,
                    // call this function on every dragend event
                    // onend: function (event) {
                    //     console.log('moved')
                    // }
                });
            if (this.resizable) {
                let edges = this.edges ? this.edges : { 
                    left: true,
                    right: true,
                    bottom: true,
                }
                this.interactable.resizable({
                    // resize from all edges and corners
                    edges,
                    listeners: {
                        move(event) {
                            const target = event.target
                            let x = (parseFloat(target.getAttribute('data-x')) || 0)
                            let y = (parseFloat(target.getAttribute('data-y')) || 0)

                            // update the element's style
                            target.style.width = event.rect.width + 'px'
                            target.style.height = event.rect.height + 'px'

                            // translate when resizing from top or left edges
                            x += event.deltaRect.left
                            y += event.deltaRect.top

                            target.style.transform = 'translate(' + x + 'px,' + y + 'px)'

                            target.setAttribute('data-x', x)
                            target.setAttribute('data-y', y)
                        }
                    },
                    modifiers: [
                        // minimum size
                        interact.modifiers.restrictSize({
                            min: { width: 250, height: 50 }
                        })
                    ],
                })
            }
            // this is used later in the resizing and gesture demos
            window.dragMoveListener = this.dragMoveListener;
        } catch (e) {
            console.log(e)
        }
    }

    dragMoveListener(event) {
        const target = event.target,
            // keep the dragged position in the data-x/data-y attributes
            x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx,
            y = (parseFloat(target.getAttribute('data-y')) || 0) + event.dy;
        // translate the element
        target.style.webkitTransform =
            target.style.transform =
            'translate(' + x + 'px, ' + y + 'px)';
        // update the posiion attributes
        target.setAttribute('data-x', x);
        target.setAttribute('data-y', y);
    }

    get initialPosition() {
        return this.state.initialPosition
    }

    set initialPosition(v) {
        const [x, y] = v
        this.state.initialPosition = v
        this.element.setAttribute('data-x', x)
        this.element.setAttribute('data-y', y)
        this.element.style.transform = `translate(${x}px, ${y}px)`
    }

    destroy() {
        if (this.interactable) {
            this.interactable.unset();
            this.interactable = null;
        }

        if (this.element.parentNode) {
            this.element.parentNode.removeChild(this.element);
        }
    }
}